import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  Select,
  InlineStack,
} from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import makeAnimated from "react-select/animated";
import Pagination from "@mui/material/Pagination";
import EllipsisText from "react-ellipsis-text";
import moment from "moment";
import { capitalizeFirstLetter } from "../Helpers";
import { CategoriesIcon } from "@shopify/polaris-icons";

const SessionsListComponent = ({ type }) => {
  const navigate = useNavigate();
  const addEditState = useRef("");
  const perPage = 50;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });
  const handleAddRecentSession = () => {
    navigate("/admin/settings/recentSessions-and-permissions/new");
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[{ label: "Email", value: "email" }]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: false,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    pageObject.isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;

    // show loader IMMEDIATELY
    setPageObject((prev) => ({
      ...prev,
      isLoading: true,
      groupedItems: [], // hide previous results
    }));

    setPage(value);
  };

  const handleClickRow = (param) => {
    //  navigate(`/admin/recent-sessions/${param}`, "_blank");
    window.open(`/admin/sessions/${param}`, "_blank");
  };
  const [isSaving, setIsSaving] = useState(false);
  const [selectedClass, setSelectedClass] = useState("");
  const [optionsClasses, setOptionsClasses] = useState([
    { label: "All", value: "all" },
  ]);
  const [optionsElements, setOptionsElements] = useState([
    { label: "All", value: "all" },
  ]);
  const [selectedElement, setSelectedElement] = useState("");
  const handleSelectChangeClass = (newValue) => {
    setSelectedClass(newValue);
  };
  const handleSelectChangeElement = (newValue) => {
    setSelectedElement(newValue);
  };
  const [selectedDate, setSelectedDate] = useState("");
  const handleChangeDate = (newValue) => {
    setSelectedDate(newValue);
  };
  const [selectedDateTo, setSelectedDateTo] = useState("");
  const handleChangeDateTo = (newValue) => {
    setSelectedDateTo(newValue);
  };
  const [selectedIsPrivate, setSelectedIsPrivate] = useState("");
  const handleChangeIsPrivate = (newValue) => {
    setSelectedIsPrivate(newValue);
  };
  const handleBookings = (param, classId) => {
    window.open(
      `/admin/sessions/${param}/classes/${classId}/bookings`,
      "_blank",
    );

    // navigate(`/admin/sessions/${param}/classes/${classId}/bookings`);
  };
  useEffect(() => {
    setPageObject((prev) => ({ ...prev, isLoading: true })); // show spinner
    fetchData();
  }, [
    ts,
    availability,
    queryValue,
    page,
    selectedClass,
    selectedDate,
    selectedElement,
    selectedDateTo,
    selectedIsPrivate,
  ]);

  async function fetchData() {
    let responseRecentSessions = "";
    let responseClasses = [];
    let responseElements = [];
    console.log(responseRecentSessions);
    try {
      responseRecentSessions = await axios.get(
        `/recent-sessions?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }&type=${type}${
          queryValue
            ? `&filter[${
                availability === "" ? "email" : availability
              }]=${queryValue}`
            : ""
        }${
          selectedElement !== "" && selectedElement !== "all"
            ? `&filter[related_class.element.id]=${selectedElement}`
            : ""
        }${
          selectedClass !== "" && selectedClass !== "all"
            ? `&filter[class_id]=${selectedClass}`
            : ""
        }${selectedDate !== "" ? `&from_date=${selectedDate}` : ""}${
          selectedDateTo !== "" ? `&to_date=${selectedDateTo}` : ""
        }${
          selectedIsPrivate !== "" && selectedIsPrivate !== "all"
            ? `&filter[related_class.is_private]=${selectedIsPrivate}`
            : ""
        }`,
      );
      console.log("test", responseRecentSessions.data.data.data);
      // setPageObject({
      //   ...pageObject,
      //   tableItems: responseRecentSessions?.data?.data?.data?.map(
      //     (item, index) => [
      //       <div
      //         className="clickableDiv"
      //         onClick={() => handleClickRow(item.id)}
      //       >
      //         {item.id}
      //       </div>,
      //       <div
      //         className="clickableDiv"
      //         onClick={() => handleClickRow(item.id)}
      //       >
      //         {item?.related_class && item?.related_class?.name
      //           ? item?.related_class?.name
      //           : "-"}
      //       </div>,
      //       <div
      //         className="clickableDiv"
      //         onClick={() => handleClickRow(item.id)}
      //       >
      //         {item?.related_class?.parent_type === "element"
      //           ? item.related_class?.element?.title
      //           : item?.related_class?.parent_type === "studio"
      //           ? item.related_class?.studio?.name
      //           : item.related_class?.sub_studio?.name}
      //       </div>,
      //       <div
      //         className="clickableDiv"
      //         onClick={() => handleClickRow(item.id)}
      //       >
      //         {item?.related_class && item?.related_class?.type ? (
      //           <Badge
      //             tone={
      //               item?.related_class?.type === "spot"
      //                 ? "attention"
      //                 : item?.related_class?.type === "duration"
      //                 ? "info"
      //                 : ""
      //             }
      //           >
      //             {capitalizeFirstLetter(item?.related_class?.type)}
      //           </Badge>
      //         ) : (
      //           "-"
      //         )}
      //       </div>,
      //       <div
      //         className="clickableDiv"
      //         onClick={() => handleClickRow(item.id)}
      //       >
      //         {item?.instructor && item?.instructor?.name
      //           ? item?.instructor?.name
      //           : "-"}
      //       </div>,
      //       <div
      //         className="clickableDiv"
      //         onClick={() => handleClickRow(item.id)}
      //       >
      //         {item?.date ? item?.date : "-"}
      //       </div>,
      //       <div
      //         className="clickableDiv"
      //         onClick={() => handleClickRow(item.id)}
      //       >
      //         {item?.launch_time ? item?.launch_time : "-"}
      //       </div>,
      //       <div
      //         className="clickableDiv"
      //         onClick={() => handleClickRow(item.id)}
      //       >
      //         {item?.finish_time ? item?.finish_time : "-"}
      //       </div>,
      //       // <div
      //       //   className="clickableDiv"
      //       //   onClick={() => handleClickRow(item.id)}
      //       // >
      //       //   {item?.related_class?.from_date
      //       //     ? item?.related_class?.from_date
      //       //     : "-"}
      //       // </div>,
      //       <div
      //         className="clickableDiv"
      //         onClick={() => handleClickRow(item.id)}
      //       >
      //         {item?.bookings_count !== null ? item?.bookings_count : "-"}
      //       </div>,
      //       <div
      //         className="clickableDiv"
      //         onClick={() => handleClickRow(item.id)}
      //       >
      //         {item?.created_at
      //           ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
      //           : "-"}
      //       </div>,
      //       <ButtonGroup>
      //         <Button
      //           onClick={() => handleBookings(item.id, item.class_id)}
      //           icon={CategoriesIcon}
      //         >
      //           Bookings
      //         </Button>
      //       </ButtonGroup>,
      //     ]
      //   ),
      //   isLoading: false,
      //   isListEmpty: !responseRecentSessions.data.data.data.length
      //     ? true
      //     : false,
      //   tableTotalPages: responseRecentSessions.data.data.total,
      // });
      const grouped = responseRecentSessions?.data?.data?.data; // now object with date keys

      const groupsArray = Object.entries(grouped).map(
        ([dateTitle, sessions]) => {
          const rows = sessions.map((item) => [
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item.id}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.related_class?.name || "-"}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.related_class?.parent_type === "element"
                ? item.related_class?.element?.title
                : item?.related_class?.parent_type === "studio"
                  ? item.related_class?.studio?.name
                  : item.related_class?.sub_studio?.name}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.related_class?.type ? (
                <Badge
                  tone={
                    item?.related_class?.type === "spot"
                      ? "attention"
                      : item?.related_class?.type === "duration"
                        ? "info"
                        : ""
                  }
                >
                  {capitalizeFirstLetter(item?.related_class?.type)}
                </Badge>
              ) : (
                "-"
              )}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.instructor?.name || "-"}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.date || "-"}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.launch_time || "-"}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.finish_time || "-"}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.total_bookings_count}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.created_at
                ? moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")
                : "-"}
            </div>,
            <ButtonGroup>
              <Button
                onClick={() => handleBookings(item.id, item.class_id)}
                icon={CategoriesIcon}
              >
                Bookings
              </Button>
            </ButtonGroup>,
          ]);

          return { dateTitle, rows };
        },
      );

      setPageObject({
        ...pageObject,
        groupedItems: groupsArray,
        isLoading: false,
        isListEmpty: groupsArray.length === 0,
        tableTotalPages: responseRecentSessions.data.data.total,
      });
    } catch (error) {
      console.log(error);
    }
    if (optionsElements.length === 1)
      try {
        responseElements = await axios.get(`/elements-list`);
        setOptionsElements((currentObjects) =>
          currentObjects.concat([
            ...responseElements.data.data.map((item, index) => {
              return {
                label: item.title,
                value: String(item.id),
              };
            }),
          ]),
        );
      } catch (error) {
        console.log(error);
      }
    // if (optionsClasses.length === 1)
    //   try {
    //     responseClasses = await axios.get(`/classes?per_pge=1000`);
    //     setOptionsClasses((currentObjects) =>
    //       currentObjects.concat([
    //         ...responseClasses.data.data.data.map((item, index) => {
    //           return {
    //             label: item.name,
    //             value: String(item.id),
    //           };
    //         }),
    //       ])
    //     );
    //   } catch (error) {
    //     console.log(error);
    //   }
  }

  useEffect(() => {
    setOptionsClasses([]);
    selectedElement !== "" &&
      axios
        .get(
          `/classes-list${
            selectedElement !== "all"
              ? `?filter[element_id]=${selectedElement}`
              : ""
          }`,
        )
        .then((result) => {
          console.log("result=", result.data.data);
          setOptionsClasses(() =>
            [{ label: "All", value: "all" }].concat([
              ...result.data.data.map((item, index) => {
                return {
                  label: item.name,
                  value: String(item.id),
                };
              }),
            ]),
          );
        })
        .catch((err) => console.log(err));
  }, [selectedElement]);

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This recentSession has been successfully verified",
  );

  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const refId = useRef(null);
  const [activeVerify, setActiveVerify] = useState(false);
  const handleChangeModalVerify = useCallback((activeVerify) => {
    setActiveVerify(!activeVerify);
    setIsSaving(false);
  }, []);
  const handleYesVerify = () => {
    setIsSaving(true);
    axios
      .post(`/recent-sessions/${refId.current}/verify`)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveVerify(!activeVerify);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  return (
    <div>
      <FormLayout>
        <FormLayout.Group>
          <Select
            label="Filter by element: "
            options={optionsElements}
            onChange={handleSelectChangeElement}
            value={selectedElement}
            labelInline
          />
          <Select
            label="Filter by class: "
            options={optionsClasses}
            onChange={handleSelectChangeClass}
            value={selectedClass}
            labelInline
          />

          <TextField
            prefix="From: "
            value={selectedDate}
            onChange={handleChangeDate}
            labelInline
            type="date"
          />
          <TextField
            prefix="To: "
            value={selectedDateTo}
            onChange={handleChangeDateTo}
            labelInline
            type="date"
          />
          <div style={{ marginRight: "0.5rem" }}>
            <Select
              label="Is Private? "
              options={[
                { label: "All", value: "" },
                { label: "Yes", value: "1" },
                { label: "No", value: "0" },
              ]}
              onChange={handleChangeIsPrivate}
              value={selectedIsPrivate}
              labelInline
            />
          </div>
        </FormLayout.Group>
      </FormLayout>
      {pageObject.groupedItems?.map((group, idx) => (
        <div key={idx} style={{ marginBottom: "1rem" }}>
          <FormLayout>
            <Text variant="headingMd" as="h6">
              {group.dateTitle}
            </Text>

            <Card padding={0}>
              <DataTable
                columnContentTypes={[
                  "text",
                  "text",
                  "text",
                  "text",
                  "text",
                  "text",
                  "text",
                  "text",
                  "text",
                  "text",
                ]}
                headings={[
                  "ID",
                  "Class Name",
                  "Parent",
                  "Type",
                  "Instructor",
                  "Date",
                  "Start",
                  "End",
                  "Total Bookings Count",
                  "Created",
                  "",
                ]}
                rows={group.rows}
                increasedTableDensity
                hasZebraStripingOnData
              />
            </Card>
          </FormLayout>
        </div>
      ))}

      {/* 
      <DataTable
        columnContentTypes={["text", "text", "text", "text"]}
        headings={[
          <Text variant="bodyMd" as="p" fontWeight="medium">
            ID
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Class Name
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Class Parent
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Class Type
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Instructor
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Date
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Start Time
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            End Time
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Total Bookings Count
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Created at
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
        ]}
        rows={pageObject.tableItems}
        verticalAlign="middle"
        increasedTableDensity
        footerContent={
          pageObject.tableItems?.length &&
          `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
        }
        hasZebraStripingOnData
      /> */}
      {emtyState}
      {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
        <div
          style={{
            paddingTop: "10px",
            textAlign: "center",
            paddingBottom: "10px",
          }}
        >
          <Pagination
            variant="outlined"
            count={Math.ceil(pageObject.tableTotalPages / perPage)}
            page={page}
            onChange={handleChangePage}
          />
          {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
        </div>
      )}
    </div>
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
};

export default SessionsListComponent;
